var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-chip',_vm._b({attrs:{"small":"","outlined":"","to":{
    name: 'TeacherDepartments',
    params: { id: _vm.value.id },
  }}},'v-chip',_vm.$attrs,false),[_c('Icon',{attrs:{"left":"","small":""}},[_vm._v("mdi-account-details")]),_vm._v(" "+_vm._s(_vm.value.description)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }